(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class ImageContainerToggle {
    constructor() {
      this.button = document.getElementById('image-container-toggle');
      this.container = document.getElementById('image-container');
      this.overlay = document.getElementById('page-overlay');
      this.isOpen = localStorage.getItem('imageContainerOpen') === 'true';
      
      if (this.button && this.container) {
        // Add click handler for the toggle button
        this.button.addEventListener('click', (e) => {
          e.stopPropagation(); // Prevent document click handler from firing
          this.toggleContainer();
        });
        
        this.overlay.addEventListener('click', () => this.hideContainer());
        
        // Add click handler to close container when clicking outside
        document.addEventListener('click', (e) => {
          if (this.isOpen && 
              !this.container.contains(e.target) && 
              !e.target.closest('.product-thumbnail-image') && 
              !e.target.closest('.product__media-toggle') &&
              !e.target.closest('#image-container-toggle')) {
            this.hideContainer();
          }
        });
        
        // Close on escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.hideContainer();
        });

        // Initialize state from localStorage
        this.loadState();
        this.setupImagePlaceholders();

        // Initialize drag and drop
        this.setupProductImageDrag();
        this.setupModalObserver();
        this.setupImageClickHandling();
      }
    }

    setupModalObserver() {
      // Watch for modal opening
      const modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.target.classList.contains('media-modal--open')) {
            // Modal has opened, initialize drag for modal images
            setTimeout(() => {
              // Clean up existing drag handlers
              document.querySelectorAll('.product-media-modal__content img').forEach(img => {
                if (img.dragStartHandler) {
                  img.removeEventListener('dragstart', img.dragStartHandler);
                }
                if (img.dragEndHandler) {
                  img.removeEventListener('dragend', img.dragEndHandler);
                }
                img.dataset.dragInitialized = false;
              });
              this.setupProductImageDrag();
            }, 300); // Increased delay to ensure modal content is fully loaded
          }
        });
      });

      // Observe all product modals
      document.querySelectorAll('.product-media-modal').forEach(modal => {
        modalObserver.observe(modal, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: false
        });
      });
    }

    setupProductImageDrag() {
      // Target all product images including those in the gallery and modal
      const productImages = document.querySelectorAll(
        '.product__media-item img, ' +
        '.product__media-list img, ' +
        '.product-media-modal__content img, ' +
        '.global-media-settings, ' +
        '.product-media-container img, ' +
        '.media img, ' +
        '.product-thumbnail-image'
      );

      productImages.forEach(img => {
        // Skip if already initialized or if not an image element
        if (img.dataset.dragInitialized || !img.tagName || img.tagName.toLowerCase() !== 'img') return;
        
        // Function to get highest quality image URL
        const getHighestQualityUrl = (img) => {
          try {
            // Get original source if available
            if (img.dataset.originalSrc) {
              return img.dataset.originalSrc;
            }
            
            const src = img.src || '';
            if (src.includes('cdn.shopify.com')) {
              return src.replace(/_(small|medium|large|grande|original|1024x1024|2048x2048|master)\./, '.');
            }
            return src;
          } catch (error) {
            console.warn('Error processing image URL:', error);
            return img.src;
          }
        };

        // Mark as initialized
        img.dataset.dragInitialized = 'true';
        img.draggable = true;
        img.style.cursor = 'grab';

        const handleDragStart = (e) => {
          e.stopPropagation(); // Prevent parent elements from interfering
          e.preventDefault(); // Prevent default to ensure our handling
          const imageUrl = getHighestQualityUrl(img);
          if (!imageUrl) {
            e.preventDefault();
            return;
          }
          e.dataTransfer.setData('text/plain', imageUrl);
          e.dataTransfer.effectAllowed = 'copy';
          
          // Add visual feedback for drag
          e.target.classList.add('being-dragged');
          e.target.style.cursor = 'grabbing';
        };

        const handleDragEnd = (e) => {
          e.target.classList.remove('being-dragged');
          e.target.style.cursor = 'grab';
        };

        // Add the event listeners
        img.addEventListener('dragstart', handleDragStart);
        img.addEventListener('dragend', handleDragEnd);
        img.addEventListener('mousedown', () => img.style.cursor = 'grabbing');
        img.addEventListener('mouseup', () => img.style.cursor = 'grab');
        
        // Store the handlers on the element for potential cleanup
        img.dragStartHandler = handleDragStart;
        img.dragEndHandler = handleDragEnd;
      });
    }

    setupImagePlaceholders() {
      const placeholders = document.querySelectorAll('.image-placeholder');
      
      placeholders.forEach(placeholder => {
        // Setup drag and drop
        placeholder.addEventListener('dragover', (e) => {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'copy';
          placeholder.classList.add('drag-over');
        });

        placeholder.addEventListener('dragleave', () => {
          placeholder.classList.remove('drag-over');
        });

        placeholder.addEventListener('drop', (e) => {
          e.preventDefault();
          placeholder.classList.remove('drag-over');
          
          let imageUrl;
          try {
            // Try to get URL from JSON data first
            const jsonData = e.dataTransfer.getData('application/json');
            if (jsonData) {
              const data = JSON.parse(jsonData);
              imageUrl = data.imageUrl;
            }
          } catch (error) {
            console.warn('Error parsing JSON data:', error);
          }
          
          // Fallback to text/plain if JSON parsing failed
          if (!imageUrl) {
            imageUrl = e.dataTransfer.getData('text/plain');
          }
          
          if (imageUrl && imageUrl.startsWith('http')) {
            this.handleImageUrl(imageUrl, placeholder);
          } else if (e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            if (file && file.type.startsWith('image/')) {
              this.handleImageUpload(file, placeholder);
            }
          }
        });

        // Setup click to upload
        placeholder.addEventListener('click', () => {
          if (!placeholder.classList.contains('has-image')) {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = (e) => {
              const file = e.target.files[0];
              if (file) {
                this.handleImageUpload(file, placeholder);
              }
            };
            input.click();
          }
        });

        // Setup remove button
        const removeBtn = placeholder.querySelector('.remove-image');
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeImage(placeholder);
        });

        // Setup resize functionality
        this.setupResize(placeholder);
      });
    }

    handleImageUrl(url, placeholder) {
      let img = placeholder.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        placeholder.appendChild(img);
      }
      
      try {
        // Clean up the URL to get original image
        let cleanUrl = url;
        if (url && url.includes('cdn.shopify.com')) {
          cleanUrl = url.split('_')[0] + url.substring(url.lastIndexOf('.'));
        }
        img.src = cleanUrl;
        img.style.display = 'block';
        placeholder.classList.add('has-image');
        
        // Save to localStorage
        this.savePlaceholderContent(placeholder.dataset.id, {
          src: cleanUrl,
          height: placeholder.style.height || 'auto'
        });
      } catch (error) {
        console.warn('Error handling image URL:', error);
      }
    }

    handleImageUpload(file, placeholder) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = placeholder.querySelector('img');
        img.src = e.target.result;
        img.style.display = 'block';
        placeholder.classList.add('has-image');
        
        // Save to localStorage
        this.savePlaceholderContent(placeholder.dataset.id, {
          src: e.target.result,
          height: placeholder.style.height || 'auto'
        });
      };
      reader.readAsDataURL(file);
    }

    removeImage(placeholder) {
      const img = placeholder.querySelector('img');
      img.src = '';
      img.style.display = 'none';
      placeholder.classList.remove('has-image');
      placeholder.style.height = 'auto';
      
      // Remove from localStorage
      localStorage.removeItem(`placeholder-${placeholder.dataset.id}`);
    }

    setupResize(placeholder) {
      const handle = placeholder.querySelector('.resize-handle');
      let isResizing = false;
      let startHeight, startY;

      handle.addEventListener('mousedown', (e) => {
        isResizing = true;
        startHeight = placeholder.offsetHeight;
        startY = e.clientY;
        
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', () => {
          isResizing = false;
          document.removeEventListener('mousemove', handleMouseMove);
          
          // Save new height to localStorage
          if (placeholder.classList.contains('has-image')) {
            const img = placeholder.querySelector('img');
            this.savePlaceholderContent(placeholder.dataset.id, {
              src: img.src,
              height: placeholder.style.height
            });
          }
        });
      });

      const handleMouseMove = (e) => {
        if (!isResizing) return;
        
        const deltaY = e.clientY - startY;
        const newHeight = startHeight + deltaY;
        
        // Update placeholder height
        placeholder.style.height = `${newHeight}px`;
        
        // Update image height to match container
        const img = placeholder.querySelector('img');
        if (img && img.style.display !== 'none') {
          img.style.height = '100%';
          img.style.width = '100%';
          img.style.objectFit = 'contain';
        }
      };
    }

    loadState() {
      const placeholders = this.container.querySelectorAll('.image-placeholder');
      placeholders.forEach(placeholder => {
        const id = placeholder.dataset.id;
        const savedState = localStorage.getItem(`placeholder-${id}`);
        if (savedState) {
          const data = JSON.parse(savedState);
          const img = placeholder.querySelector('img');
          img.src = data.src;
          img.style.display = 'block';
          img.style.height = '100%';
          img.style.width = '100%';
          img.style.objectFit = 'contain';
          placeholder.classList.add('has-image');
          if (data.height) {
            placeholder.style.height = data.height;
          }
        }
      });
    }

    savePlaceholderContent(id, content) {
      localStorage.setItem(`placeholder-${id}`, JSON.stringify(content));
    }

    toggleContainer() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.showContainer(true);
      } else {
        this.hideContainer(true);
      }
    }

    showContainer(saveState = true) {
      this.container.classList.add('active');
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (saveState) {
        localStorage.setItem('imageContainerOpen', 'true');
      }
    }

    hideContainer(saveState = true) {
      this.container.classList.remove('active');
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
      if (saveState) {
        localStorage.setItem('imageContainerOpen', 'false');
      }
    }

    setupImageClickHandling() {
      document.addEventListener('click', (e) => {
        // Prevent zoom modal from opening for product media items
        const mediaToggle = e.target.closest('.product__media-toggle');
        const productImage = e.target.closest('.product-thumbnail-image');
        
        if (mediaToggle || productImage) {
          e.preventDefault();
          e.stopPropagation();
          
          // Show container before adding image
          if (!this.isOpen) {
            this.showContainer();
          }
          
          // Get the actual image element
          const imageElement = mediaToggle ? 
            mediaToggle.closest('.product__media').querySelector('img') : 
            productImage;
            
          this.addImageToContainer(imageElement);
          
          // Prevent event bubbling
          return false;
        }
      }, true);
    }

    addImageToContainer(imageElement) {
      // Find the first empty placeholder
      const placeholders = this.container.querySelectorAll('.image-placeholder:not(.has-image)');
      if (placeholders.length === 0) {
        console.warn('No empty placeholders available');
        return;
      }

      const targetPlaceholder = placeholders[0];
      
      // Get highest quality image URL
      let imageUrl;
      
      // Try to get URL from parent container's data attributes first
      const productThumbnail = imageElement.closest('[data-product-thumbnail]');
      if (productThumbnail && productThumbnail.dataset.imageUrl) {
        imageUrl = productThumbnail.dataset.imageUrl;
      } else {
        // Fallback to image src
        imageUrl = imageElement.dataset.originalSrc || imageElement.src;
      }

      // Clean up Shopify CDN URL to get highest quality
      if (imageUrl.includes('cdn.shopify.com')) {
        imageUrl = imageUrl.split('_')[0] + imageUrl.substring(imageUrl.lastIndexOf('.'));
      }

      // Add image to placeholder with proper sizing
      const img = targetPlaceholder.querySelector('img');
      img.src = imageUrl;
      img.style.display = 'block';
      img.style.height = '100%';
      img.style.width = '100%';
      img.style.objectFit = 'contain';
      targetPlaceholder.classList.add('has-image');

      // Save to localStorage
      this.savePlaceholderContent(targetPlaceholder.dataset.id, {
        src: imageUrl,
        height: targetPlaceholder.style.height || 'auto'
      });
    }

    handleImageDrop(imageData) {
      const placeholders = this.container.querySelectorAll('.image-placeholder:not(.has-image)');
      if (placeholders.length === 0) return;

      const targetPlaceholder = placeholders[0];
      const img = targetPlaceholder.querySelector('img');
      img.src = imageData.imageUrl;
      img.style.display = 'block';
      img.style.height = '100%';
      img.style.width = '100%';
      img.style.objectFit = 'contain';
      targetPlaceholder.classList.add('has-image');

      this.savePlaceholderContent(targetPlaceholder.dataset.id, {
        src: imageData.imageUrl,
        height: targetPlaceholder.style.height || 'auto'
      });
    }
  }

  customElements.define('image-container-toggle', ImageContainerToggle);
  const imageContainerToggle = new ImageContainerToggle();
  window.imageContainerToggle = imageContainerToggle; // Make accessible globally

  class HeaderImageHandler {
    constructor() {
      this.dropZone = document.querySelector('[data-drop-zone]');
      this.initializeDropZone();
      this.initializeDraggableImages();
    }

    initializeDropZone() {
      if (!this.dropZone) return;
      
      this.dropZone.addEventListener('dragover', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dropZone.classList.add('drag-over');
      });

      this.dropZone.addEventListener('dragleave', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dropZone.classList.remove('drag-over');
      });

      this.dropZone.addEventListener('drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dropZone.classList.remove('drag-over');

        const imageData = JSON.parse(e.dataTransfer.getData('application/json'));
        if (imageData.imageUrl) {
          this.handleImageDrop(imageData);
        }
      });
    }

    initializeDraggableImages() {
      document.addEventListener('DOMContentLoaded', () => {
        const productThumbnails = document.querySelectorAll('[data-product-thumbnail]');
        
        productThumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('dragstart', (e) => {
            const imageData = {
              imageUrl: thumbnail.dataset.imageUrl,
              title: thumbnail.dataset.title,
              mediaId: thumbnail.dataset.mediaId
            };
            e.dataTransfer.setData('application/json', JSON.stringify(imageData));
          });
        });
      });
    }

    handleImageDrop(imageData) {
      // Create new image element
      const img = document.createElement('img');
      img.src = imageData.imageUrl;
      img.alt = imageData.title;
      img.classList.add('dropped-image');
      
      // Clear existing images if needed
      this.dropZone.innerHTML = '';
      
      // Add the new image
      this.dropZone.appendChild(img);
    }
  }

  // Initialize the handler
  new HeaderImageHandler();

  } catch(e) { console.error(e); }
})();
})();
